import React from 'react';
import { IonIcon } from '@ionic/react';
import { bookmarkOutline } from 'ionicons/icons';
import { Card, Gradient } from '../../Global/styles';
import { Story } from '../../../models/Story';
import { StoryCardContainer } from './storyCardStyles';
import { NavLink } from 'react-router-dom';
import { checkImage } from '../../componentUtils';
import {
	StoryPlaceDescription,
	StoryPlaceMeta,
} from '../../StoryPage/StoryPois/storyPlacesStyles';
import { CardTitleContainer } from '../FilteredCarousel/carouselStyles';
import LoadingImage from '../../Global/LoadingImage/LoadingImage';
import { StoryHelper } from '../../../models/helpers/Helpers';
import BookmarkStoryButton from '../../Global/BookmarkButton/BookmarkStoryButton';

type StoryProps = {
	story: Story;
	showDescription?: boolean;
};

const StoryCard: React.FC<StoryProps> = ({
	story,
	showDescription = false,
}) => {
	//{(typeof image === 'string') ? image : "https://picsum.photos/200/300"}
	return (
		<StoryCardContainer>
			<NavLink to={'/story/' + story.id}>
				<Card $height={224}>
					<LoadingImage src={checkImage(story.image)} />
					<Gradient />

					<CardTitleContainer>
						<h3>{story.title}</h3>
						<StoryPlaceMeta>
							{StoryHelper.generateMetaString(story)}
						</StoryPlaceMeta>
					</CardTitleContainer>
				</Card>
			</NavLink>

			<BookmarkStoryButton storyId={story.id} />
			{showDescription && (
				<StoryPlaceDescription className="ph3">
					{story.short_description}
				</StoryPlaceDescription>
			)}
		</StoryCardContainer>
	);
};

export default StoryCard;
